import { gql } from '@urql/core';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { Espin_Event, EventInfoFragment } from '../../../generated/spin-graphql';

type Props = {
    eventData: EventInfoFragment;
};

gql`
    fragment EventInfo on espin_event {
        short_description
        event_start_date
        event_end_date
        body_content
        rules_content
    }
`;

export const EventInfo: React.FC<Props> = ({ eventData }) => {
    const [overviewSelected, setOverviewSelected] = useState<boolean>(true);
    return (
        <div className="left-panel">
            <div className="event-navigation">
                <button
                    onClick={() => setOverviewSelected(true)}
                    className={`button medium-button${overviewSelected ? ' active' : ''}`}
                >
                    Overview
                </button>
                {eventData.rules_content && (
                    <button
                        onClick={() => setOverviewSelected(false)}
                        className={`button medium-button${!overviewSelected ? ' active' : ''}`}
                    >
                        Rules
                    </button>
                )}
            </div>
            <div className="event-page-card">
                {overviewSelected ? (
                    <>
                        <h2 className="title">Overview</h2>
                        <div
                            className="event-description"
                            dangerouslySetInnerHTML={{ __html: eventData.short_description }}
                        ></div>
                        <div className="formatted-content">
                            <h3>Dates</h3>
                            <p>
                                {format(new Date(eventData.event_start_date), 'cccc MMMM do')}
                                {' - '}
                                {format(new Date(eventData.event_end_date), 'cccc MMMM do')}
                            </p>
                        </div>
                        <div
                            className="formatted-content"
                            dangerouslySetInnerHTML={{ __html: eventData.body_content }}
                        />
                    </>
                ) : (
                    <>
                        <h2 className="title">Rules</h2>
                        <div
                            className="formatted-content"
                            dangerouslySetInnerHTML={{ __html: eventData.rules_content }}
                        />
                    </>
                )}
            </div>
        </div>
    );
};
